import { useEffect, useState } from "react";
import { FadingVideo } from "@/components/eclipsia/FadingVideo";
import { mediaUrl, SITE } from "@/lib/api";

/* Crossfading still-image slideshow (used once the owner uploads photos). */
const Slideshow = ({ images, holdMs = 5000 }) => {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % images.length), holdMs);
    return () => clearInterval(t);
  }, [images.length, holdMs]);
  return images.map((src, i) => (
    <img
      key={src}
      src={src}
      alt=""
      className="absolute inset-0 w-full h-full object-cover transition-opacity duration-1000"
      style={{ opacity: i === idx ? 1 : 0 }}
    />
  ));
};

export const Backdrop = ({ images = [], video = SITE.video }) => (
  <>
    <div className="absolute inset-0 z-0" data-testid="page-backdrop">
      {images.length > 0 ? (
        <Slideshow images={images.map(mediaUrl)} />
      ) : (
        <>
          <img src={SITE.poster} alt="" className="absolute inset-0 w-full h-full object-cover opacity-60" />
          <FadingVideo src={mediaUrl(video)} poster={SITE.poster} className="absolute inset-0 w-full h-full object-cover" />
        </>
      )}
    </div>
    <div className="absolute inset-0 z-[1] bg-gradient-to-b from-black/40 via-transparent to-black/50" />
  </>
);
